import { render } from "./MatchEventSlotEditor.vue?vue&type=template&id=56849a36&scoped=true"
import script from "./MatchEventSlotEditor.vue?vue&type=script&lang=js"
export * from "./MatchEventSlotEditor.vue?vue&type=script&lang=js"

import "@/assets/style.css?vue&type=style&index=0&lang=css"
import "./MatchEventSlotEditor.vue?vue&type=style&index=1&id=56849a36&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56849a36"]])

export default __exports__